/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'

function UserId(props){
   useEffect(() => {
      window.userid=props.match.params.userid;
      console.log('window.userid:', window.userid);
   }, []);

   return (
      < Redirect to='/' />
   );
}
export default UserId;